<div id="slider-marketing" class="carousel slide mb-xl" data-ride="carousel" data-interval="3000">
  <ol class="carousel-indicators mb-0">
    @for (slide of slides; track slide; let i = $index) {
      <li data-target="#slider-marketing"
        [ngClass]="showIndicators(slides) ? ( i === 0 ? 'active' : ''): 'hidden' "
        [attr.data-slide-to]="i">
      </li>
    }
  </ol>

  <div class="carousel-inner">
    @for (slide of slides; track slide; let i = $index) {
      <div class="carousel-item"
        [ngClass]="{'active' : i === 0}">
        @if (slide.link) {
          <a
            href="{{slide.link}}"
            [attr.aria-label]="slide.name"
            target="_blank"
            class="mtm-slide"
            [id]="'slide-' + i"
            (click)="mtmEvent(slide.name, i+1)">
            <img src="{{ CDN }}/marketing-management/{{slide.image}}"
              alt="{{slide.name}}">
            </a>
          }
          @if (!slide.link) {
            <span
              [id]="'slide-' + i">
              <img src="{{ CDN }}/marketing-management/{{slide.image}}"
                alt="{{slide.name}}"
                class="mtm-slide"/>
              </span>
            }
          </div>
        }
      </div>
      @if (slides?.length > 1) {
        <a class="carousel-control-prev"
          href="#slider-marketing"
          role="button"
          data-slide="prev"
          >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Vorher</span>
        </a>
      }
      @if (slides?.length > 1) {
        <a class="carousel-control-next" href="#slider-marketing" role="button" data-slide="next"
          >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Nächste</span>
        </a>
      }
    </div>
